import { render, staticRenderFns } from "./FetchUserDetails.vue?vue&type=template&id=2b33012a&scoped=true&"
import script from "./FetchUserDetails.vue?vue&type=script&lang=js&"
export * from "./FetchUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./FetchUserDetails.vue?vue&type=style&index=0&id=2b33012a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33012a",
  null
  
)

export default component.exports